import type BackOfficeConnector from "../data/backOfficeConnector";
import type { IPagination } from "../data/types";
import type EventBus from "../services/eventBus";
import RepositoryBase from "./repositoryBase";
import type { ICreateRepository } from "./types";
import type GetSystemComponentOutagesRequest from "../entities/getSystemComponentOutagesRequest";
import SystemComponentOutageResponse from "../entities/systemComponentOutageResponse";
import type { SystemComponentOutage } from "entities/systemComponentOutageRequest";

export default class OutageRepository
  extends RepositoryBase<BackOfficeConnector>
  implements ICreateRepository<SystemComponentOutageResponse>
{
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAll(pagination: IPagination, filter: GetSystemComponentOutagesRequest) {
    return this.callApi(
      api =>
        api
          .all("infrastructure")
          .all("system_component_outage_search")
          .postPagedEntities<SystemComponentOutageResponse>({ ...filter, ...pagination }, SystemComponentOutageResponse),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
  }

  get(outageId: string) {
    return this.callApi(
      api => api.all("infrastructure").one("system_component_outages", outageId).getEntity(SystemComponentOutageResponse),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
  }

  create(outage: SystemComponentOutage) {
    return this.callApi(
      api => api.all("infrastructure").all("system_component_outages").postEntity(outage, SystemComponentOutageResponse),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
  }

  update(outage: SystemComponentOutageResponse) {
    return this.callApi(
      api =>
        api.all("infrastructure").one("system_component_outages", outage.id).putEntity(outage, SystemComponentOutageResponse),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
  }

  delete(outage: SystemComponentOutageResponse) {
    return this.callApi(api => api.all("infrastructure").one("system_component_outages", outage.id).delete(outage), {
      ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
    });
  }
}
